import React from 'react';
import { useTranslation } from "react-i18next";
import MenuPopover from '../Items/Popover';
import MenuPopoverPositions from '../Items/PopoverPositions';
import { NavLink } from 'react-router-dom';

const Navigation = () =>{

    const { t } = useTranslation();

    const languages = [
        {
          name: t("languague.en.label"),
          value: 'en',
          icon: 'icon-usa.png'
        },
        {
          name: t("languague.es.label"),
          value: 'es',
          icon: 'icon-colombia.png'
        },
    ]

    return(
        <div className="relative bg-white border-y-2 border-gray-100">
            <div className="max-w-7xl mx-auto">
                <nav className="items-center">
                    <div className="flex justify-between md:space-x-10 py-2">
                        <div className="flex justify-start">
                            <div className="pr-2 py-2 border-r-2 border-gray-100">
                                <NavLink to="doctorados/" className={({isActive}) => 
                                    "text-base font-medium " + (!isActive ? "text-gray-500 hover:text-slate-900" : "text-slate-900 underline underline-offset-2")
                                }>{t("general.label")}</NavLink>
                            </div>
                            <div className="p-2 border-gray-100 border-r-2 lg:border-none">
                                <MenuPopoverPositions languages={languages}></MenuPopoverPositions>
                            </div>
                        </div>
                        <div>
                            <MenuPopover languages={languages}></MenuPopover>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    )
}

export default Navigation;